jQuery(document).ready(function($){

/**************
* Smooth anchor scroll
*/ 
$('a.anchor:not([href="#"])').on('click', function(event){
    event.preventDefault();
    event.stopImmediatePropagation();

    // Fa ricalcolare a slick l'altezza, altrimenti lo slider presente nella tab nascosta risulta alto 0 e quindi non si vede
    //$('.slider-gallery').slick('setPosition');

    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {

            // se scrolli con il mouse si interrompe lo smooth scroll
            $('html, body').bind('mousewheel', function(e){ 
                $(this).stop();
            });

            $('html, body').animate({
                scrollTop: target.offset().top -130
            }, 600);

            return false;
        }
    }
});

/**************
* Back to top
*/ 

$(window).scroll(function() {
    if ($(this).scrollTop() >= 900) {       
        $('.back-to-top').fadeIn(200);    
    } else {
        $('.back-to-top').fadeOut(200);   
    }
});
$('.back-to-top').click(function() {   
    //console.log('clic');
    $('body,html').animate({
        scrollTop: 0            
    }, 500);
});

// Polyfill per IE11
//https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill

(function(){
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent (event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent( 'CustomEvent');
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

// Carrello: comando la form coupon dalla nostra "form" finta
$(document).on('click', '#trigger_coupon', function(e) {
    e.preventDefault();
    $('#coupon_code').val($('#trigger_coupon_code').val());
    $('[name="apply_coupon"]').click();
});

// Carrello apertura campo coupon al click
$(".coupon label").on('click', function(e) {
    e.preventDefault();
    $(".coupon .couponWrap").slideToggle();
});

// Cassa: comando la form coupon dalla nostra "form" finta
$(document).on('click', '#trigger_coupon', function(e) {
    e.preventDefault();
    $('#coupon_code').val($('#trigger_coupon_code').val());
    $('form.checkout_coupon').submit();
});

// Cart remove item
$(document).on('click', 'button.remove', function(e) {
    e.preventDefault();
    $(this).next('a.remove')[0].click();
});

// Loading su aggiunta al carrello
$(".button-loading-wrap .button").click(function(event){
    event.preventDefault();
    $(this).parent().removeClass("cart-is-updated").addClass("loading");
})

$(document.body).on('added_to_cart', function(){
    var $btnLoadingWrap = $(".button-loading-wrap");

    $btnLoadingWrap.removeClass("loading").addClass("cart-is-updating");
    setTimeout(function() {
        $btnLoadingWrap.removeClass("cart-is-updating").addClass("cart-is-updated");
    }, 2000);
});

$(document.body).on('wc_fragments_refreshed', function(){
    var $itemPurchase = $('#itemPurchase');

    if ($itemPurchase.attr('data-ment-added-to-cart')) {
        var $mcT = $('.minicartTrigger');

        if ($itemPurchase.attr('data-ment-added-first-item')) {
            setTimeout(function() {
                $mcT.click();
            }, 300);
        }
        else {
            $mcT.addClass("is-bouncing").on("animationend", function(){
                $(this).removeClass("is-bouncing");
            });
        }

        $itemPurchase.removeAttr('data-ment-added-to-cart');
        $itemPurchase.removeAttr('data-ment-added-first-item');
    }
});

// Evento custom, rif. plugins/woo-ajax-add-to-cart/assets/woo-ajax-add-to-cart.min.js
/*
$(document.body).on('ment_not_added_to_cart', function(){
    var $btnLoading = $(".button-loading-wrap.loading");
    $btnLoading.removeClass("loading").addClass("is-loaded");

    setTimeout(function() {
        $btnLoading.find(".cart-msgs-wrap").css('opacity','1');
        $btnLoading.find(".error-cart").removeClass('hide');
        //$btnLoading.find(".view-cart").addClass('hide');
        $btnLoading.removeClass("is-loaded").addClass("cart-is-updated");
    }, 2000);
});
*/

/* Google Autocomplete
 * https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
 */

/* IMPORTANT! */
/* Include the libraries=places parameter when you first load the API.
   For example:  <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places"> */

/*
var placeSearch, autocomplete = {};

function initAutocomplete(fieldPrefix) {

    var input = document.getElementById(fieldPrefix + '_address_1');

    google.maps.event.addDomListener(input, 'keydown', function(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    });

    // Create the autocomplete object, restricting the search to geographical location types.
    autocomplete[fieldPrefix] = new google.maps.places.Autocomplete(input, {types: ['geocode']});

    // When the user selects an address from the dropdown, populate the address fields in the form.
    if (fieldPrefix == 'billing') {
        autocomplete[fieldPrefix].addListener('place_changed', fillInAddressBilling);
    }
    else if (fieldPrefix == 'shipping') {
        autocomplete[fieldPrefix].addListener('place_changed', fillInAddressShipping);
    }

    //autocomplete.addListener('place_changed', fillInAddress);
}

function fillInAddressBilling() {
    fillInAddress('billing');
}

function fillInAddressShipping() {
    fillInAddress('shipping');
}

function fillInAddress(fieldPrefix) {
    var componentForm = {
        street_number: {
            nameFormat: 'short_name',
            inputId: fieldPrefix + '_address_1_number',
        },
        route: {
            nameFormat: 'long_name',
            inputId: fieldPrefix + '_address_1',
        },
        administrative_area_level_2: {
            nameFormat: 'short_name',
            inputId: fieldPrefix + '_state',
        },
        administrative_area_level_3: {
            nameFormat: 'long_name',
            inputId: fieldPrefix + '_city',
        },
        country: {
            nameFormat: 'short_name',
            inputId: fieldPrefix + '_country',
        },
        postal_code: {
            nameFormat: 'short_name',
            inputId: fieldPrefix + '_postcode',
        },
    };

    // Get the place details from the autocomplete object.
    var place = autocomplete[fieldPrefix].getPlace();

    for (var component in componentForm) {
        var input = document.getElementById(componentForm[component].inputId);
        if (input) {
            input.value = '';
            input.disabled = false;
        }

        //document.getElementById(componentForm[component].inputId).value = '';
        //document.getElementById(componentForm[component].inputId).disabled = false;
    }

    // Get each component of the address from the place details
    // and fill the corresponding field on the form.
    for (var i = 0; i < place.address_components.length; i++) {
        //console.log(place.address_components[i]);

        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
            //console.log(addressType);

            var val = place.address_components[i][componentForm[addressType].nameFormat];
            var input = $('#'+componentForm[addressType].inputId);

            input.val(val);

            input.trigger('change');
            //if (input.is('select')) {
            //    input.trigger('change');
            //}
        }
    }
}

if ($('#billing_address_1').length > 0) {
    initAutocomplete('billing');
}

if ($('#shipping_address_1').length > 0) {
    initAutocomplete('shipping');
}

// need to stop prop of the touchend event
if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
    if (document.getElementsByClassName('pac-container').length) {
        setTimeout(function() {
            var container = document.getElementsByClassName('pac-container')[0];
            container.addEventListener('touchend', function(e) {
                e.stopImmediatePropagation();
            });
        }, 500);
    }
}
*/

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

// Minicart
var triggered = false; 

$(document).on('click', '.minicartTrigger', function(e) {
    e.preventDefault();

    if (! triggered) {
        $('.minicartWrapper').addClass('is-open');
        setTimeout(function() {
            triggered = true;
        }, 300);
    }
    else {
        $('.minicartWrapper').removeClass('is-open');
    }
});

$(document).click(function (e) {
    e.stopPropagation();

    if (triggered == true) {
        $('.minicartWrapper').removeClass('is-open');
        triggered = false;
    }
})

// Minicart - bottone Svuota
// Rif. plugins/woocommerce/assets/js/frontend/add-to-cart.js - AddToCartHandler.prototype.onRemoveFromCart
$(document).on('click', '#minicartEmptyCart', function(e) {
    e.preventDefault();

    $(".cart-msgs-wrap").css('opacity','0');

    $.post(
        wc_add_to_cart_params.ajax_url, 
        {
            'action': 'minicartEmptyCart'
        },
        function(response) {
            if ( ! response || ! response.fragments ) {
                return;
            }

            // Azioni specifiche di "pulizia" per la pagina della mappa
            if ($('body').hasClass('page-template-prenota-ombrellone-2')) {

                // Aggiorno live i pin della mappa
                var markerIconUrl;
                var newIconUrl;
                var newIcon;
                for (const ombr in ombrMarkers) {

                    if (ombrMarkers[ombr].mentPrenotato == true) {

                        // Sostituisco l'icona attuale
                        markerIconUrl = ombrMarkers[ombr].getIcon().url;
                        newIcon = ombrMarkers[ombr].getIcon();
                        newIcon.url = markerIconUrl.indexOf('Nel-carrello-selezionato') !== -1 ? markerIconUrl.replace('Nel-carrello-selezionato', 'Libero') : markerIconUrl.replace('Nel-carrello', 'Libero');
                        ombrMarkers[ombr].setIcon(newIcon);

                        // Resetto l'icona precedente 
                        delete ombrMarkers[ombr].mentPrevIconUrl;

                        // Resetto lo stato dell'ombrellone
                        ombrMarkers[ombr].mentPrenotato = false;
                        ombrMarkers[ombr].mentOccupato = false;
                    }
                } 

                // Resetto il timeout scadenza carrello
                $('#msgTimeout').html('');

                $('#itemInfo').hide();
                $('#itemLegend').show();
                //$('#itemSummary').hide();
            }

            $( document.body ).trigger( 'removed_from_cart', [ response.fragments, response.cart_hash ] );
        },
        'json'
    );
});

// Mostra / Nascondi password
$('#password').focus(function() {
    $(this).next('.viewIcon').show();
});
$('.viewIcon').click(function() {
    if ($('#password').attr('type') == 'password') {
        $('#password').attr('type', 'text');

    } else {
        $('#password').attr('type', 'password');
    }
    $(this).toggleClass('viewText')
});

});
